/**
 * Core – Due dates page
 */

export default {
  due: {
    pageSubtitle: "Here you can see your due dates",
    dueDates: "Due dates",
    yourDD: "Your due dates",
    dashboard: "Dashboard",
    typeOfRep: "Type of report",
    country: "Country",
    periodType: "Period type",
    yVat: "Yearly VAT",
    qVat: "Quarterly VAT",
    mVat: "Monthly VAT",
    period: "Period",
    expDate: "Expect date",
    notFilled: `You don't have filled VAT return.`,
  },
};
